import { render, staticRenderFns } from "./CharacterMatchesView.vue?vue&type=template&id=33f4c458&"
import script from "./CharacterMatchesView.vue?vue&type=script&lang=js&"
export * from "./CharacterMatchesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports